export * from './encounterWriteGuard'
export * from './accessStorage'
export * from './ClassName'
export * from './currency'
export * from './fileIcon'
export * from './filter'
export * from './formatter'
export * from './hasPermission'
export * from './helper'
export * from './hospitalName'
export * from './internationalPhone'
export * from './invertMapKeys'
export * from './isResultsTab'
export * from './nameSplit'
export * from './RegExp'
export * from './resolveApiAssetUrl'
export * from './responsive'
export * from './routeUtils'
export * from './startEncounter'
export * from './style'
export * from './toast'
export * from './transformer'
export * from './vitals'

// Utility to extract unique dynamic keys in the pattern {{key}} from a string
export function extractDynamicKeys(content: string): string[] {
  const regex = /{{\s*([\w.]+)\s*}}/g
  const keys = new Set<string>()
  let match
  while ((match = regex.exec(content)) !== null) {
    keys.add(match[1])
  }
  return Array.from(keys)
}

// Utility to normalize hourly frequency input
export function normalizeHourlyFrequency(input: string): string | null {
  if (!input) return null

  const trimmed = input.trim().toLowerCase()

  // Pattern for "Every X hours" format (case insensitive)
  const everyHoursPattern = /every\s+(\d+)\s+hours?/i
  const everyMatch = trimmed.match(everyHoursPattern)

  if (everyMatch) {
    const hours = parseInt(everyMatch[1], 10)
    if (hours > 0 && hours <= 72) {
      const label = hours === 1 ? 'hour' : 'hours'
      return `Every ${hours} ${label}`
    }
    return null
  }

  // Pattern for "QXH" format (case insensitive)
  const qHoursPattern = /q(\d+)h/i
  const qMatch = trimmed.match(qHoursPattern)

  if (qMatch) {
    const hours = parseInt(qMatch[1], 10)
    if (hours > 0 && hours <= 72) {
      return `Q${hours}H`
    }
    return null
  }

  return null
}
